import React from 'react';
import PropTypes from 'prop-types';
import './PatientList.css';

const PatientList = ({ patients, onSelectPatient }) => {
  return (
    <div className="patient-list-container">
      <h3 id="patient-list-heading">Pacientes Agendados</h3>
      <ul className="patient-list" aria-labelledby="patient-list-heading">
        {patients.length > 0 ? (
          patients.map((patient) => (
            <li key={patient.id} className="patient-item">
              <button
                onClick={() => onSelectPatient(patient)}
                className="patient-item-button"
                aria-label={`Selecionar paciente ${patient.name}`}
              >
                <strong>Nome:</strong> {patient.name} <br />
                {patient.email && (
                  <>
                    <strong>Email:</strong> {patient.email} <br />
                  </>
                )}
                {patient.telefone && (
                  <>
                    <strong>Telefone/WhatsApp:</strong> {patient.telefone}{' '}
                    <br />
                  </>
                )}
                <strong>Data/Hora:</strong>{' '}
                {new Date(patient.dataHora.seconds * 1000).toLocaleString(
                  'pt-BR',
                  { timeZone: 'America/Sao_Paulo' }
                )}
              </button>
            </li>
          ))
        ) : (
          <li className="no-patient-item">Nenhum paciente agendado.</li>
        )}
      </ul>
    </div>
  );
};

PatientList.propTypes = {
  patients: PropTypes.array.isRequired,
  onSelectPatient: PropTypes.func.isRequired,
};

export default PatientList;
